import { Box } from '@mui/system';
import { MenuAppBar } from 'remote/global';
import { useLanguageMenuItems } from 'utils/hooks/useMenuItems';
import { useUIDrawer } from 'api/queries/ui';
import ResetPasswordForm from 'components/forms/ResetPasswordForm/ResetPasswordForm';
import { CardContainer } from './LoginView';

function ResetPasswordTokenView() {
  const { setIsMobileDrawerOpen } = useUIDrawer();
  const langMenuItems = useLanguageMenuItems();

  return (
    <Box>
      <MenuAppBar
        env={window.MOBIFER_ENV}
        menuItems={langMenuItems}
        onLanguageChange={() => {}}
        setIsMobileDrawerOpen={setIsMobileDrawerOpen}
      />
      <CardContainer>
        <ResetPasswordForm />
      </CardContainer>
    </Box>
  );
}

export default ResetPasswordTokenView;
